import React, { useEffect, useState } from 'react'
import Loader from 'react-loader-spinner'

import img_perfil from '../../../assets/images/img_perfil.png'
import Button from '../../atoms/button/button'

import useMediaQuery from '../../../utils/useMediaQuery'

import { jsonToHash } from '../../../utils/crypto'
import getUserInfo from '../../../utils/getUserInfo'
import { pushEventData } from '../../../utils/pushEventDataLayer'
import gameServices from '../../../services/game-service'
import {
  gameId,
  datesFaseActivities,
  idsGameList,
} from '../../../constants/activity-constants'
import userSessionStorage from '../../../utils/userSessionStorage'

import './content-profile.scss'
import { navigate } from 'gatsby'
import formatDateStr from '../../../utils/formatDateStr'
import { textCountry, text_replica_content_proifile1 } from './replica-content-profile'

const ContentProfile = () => {
  const isMobile = useMediaQuery()
  const userInfo = getUserInfo()
  const session = new userSessionStorage()
  const [lifesUser, setLifesUser] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [isLoadingRanking, setIsLoadingRanking] = useState(true)
  const [userRankingFase1, setUserRankingFase1] = useState([])
  const [userRankingFase2, setUserRankingFase2] = useState([])

  const handleDataLayer = async () => {
    pushEventData({
      event: 'Interacciones_Perfil_UCole',
      label: 'www.nosotrasonline.com.co/universo-cole/perfil',
      action: 'view',
      user_data: userInfo && [
        await jsonToHash({
          nombre: userInfo.name,
          apellido: userInfo.lastName,
          celular: userInfo.cellPhone,
          correo: userInfo.email,
          ciudad: userInfo.location.cityName,
          departamento: userInfo.location.countryStateName,
          pais: userInfo.countryName,
        }),
      ],
      log_status: userInfo ? 'Yes' : 'Not',
    })
  }

  useEffect(() => {
    handleDataLayer()
  }, [])

  useEffect(() => {
    getLifes()
    getRanking('fase1')
    getRanking('fase2')
  }, [])

  const getLifes = () => {
    let tokenId = session.getToken()?.idToken
    const config = {
      headers: tokenId
        ? {
            Authorization: tokenId,
          }
        : undefined,
    }

    gameServices.getLife(gameId, config).then(res => {
      if (res.status === 200) {
        setLifesUser(res.data.totalLives)
        setIsLoading(false)
      }
    })
  }

  const getRanking = fase => {
    let tokenId = session.getToken()?.idToken

    const payload = {
      idList: idsGameList,
      phase: fase === 'fase1' ? 0 : 1,
      startDate:
        fase === 'fase1'
          ? datesFaseActivities.datesTopFase1.startDate
          : datesFaseActivities.datesTopFase2.startDate,
      endDate:
        fase === 'fase1'
          ? datesFaseActivities.datesTopFase1.endDate
          : datesFaseActivities.datesTopFase2.endDate,
    }

    const config = {
      headers: tokenId
        ? {
            Authorization: tokenId,
          }
        : undefined,
    }

    gameServices.getUserRankingMultiGames(payload, config).then(res => {
      if (res.status === 200) {
        fase === 'fase1'
          ? setUserRankingFase1(res.data)
          : setUserRankingFase2(res.data)
        setIsLoadingRanking(false)
      }
      if (res.status === 500) {
        console.log('algo anda mal')
      }
    })
  }

  const ContainerInfo = ({ fase2 }) => {
    return (
      <div className="f-content-profile-info-points__container">
        <span className="f-content-profile-info-points__container__title ">
          <h2>Fase {fase2 ? '2' : '1'}</h2>
          <p>
            {' '}
            {fase2
              ? formatDateStr(
                  datesFaseActivities.datesTopFase2Front,
                  'Del $startDate.date $startDate.month al $endDate.date $endDate.month'
                )
              : formatDateStr(
                  datesFaseActivities.datesTopFase1,
                  'Del $startDate.date $startDate.month al $endDate.date $endDate.month'
                )}
          </p>
        </span>
        <div className="f-content-profile-info-points__container__content">
          <h3>Tus Puntos</h3>
          <span className="f-spanNumber">
            {isLoadingRanking ? (
              <Loader type="Oval" color="#c1208b" height={25} width={25} />
            ) : fase2 ? (
              userRankingFase2.point
            ) : (
              userRankingFase1.point
            )}
          </span>
          <h3 className="f-h3Name">Tu Puesto</h3>
          <span>
            {isLoadingRanking ? (
              <Loader type="Oval" color="#c1208b" height={25} width={25} />
            ) : fase2 ? (
              userRankingFase2.position
            ) : (
              userRankingFase1.position
            )}
          </span>
        </div>
      </div>
    )
  }
  return (
    <div className="f-content-profile-container">
      <div className="f-content-profile-info-user">
        <h2>
          ¡Hola <span>{userInfo?.name}!</span>
        </h2>
        <span className="f-content-profile-info-user__lifes">
          {textCountry.text1}{' '}
          <b>
            {isLoading ? (
              <Loader type="Oval" color="#ffffff" height={25} width={25} />
            ) : (
              lifesUser
            )}{' '}
            vidas
          </b>
        </span>
        {!isMobile && (
          <img src={img_perfil} alt="decoracion del perfil de la usuaria" />
        )}
      </div>
      <div className="f-content-profile-info-points">
        <p className="f-textPoints">
          {text_replica_content_proifile1}
        </p>
        <div className="f-content-profile-info-points__wrapper-info">
          <ContainerInfo />
          <ContainerInfo fase2 />
        </div>
        <Button
          className="f-button-perfil"
          onClick={async () => {
            pushEventData({
              event: 'Interacciones_Perfil_UCole',
              label: '¡Quiero jugar!',
              user_data: userInfo && [
                await jsonToHash({
                  nombre: userInfo.name,
                  apellido: userInfo.lastName,
                  celular: userInfo.cellPhone,
                  correo: userInfo.email,
                  ciudad: userInfo.location.cityName,
                  departamento: userInfo.location.countryStateName,
                  pais: userInfo.countryName,
                }),
              ],
              log_status: userInfo ? 'Yes' : 'Not',
            })
            navigate('/jugar')
          }}
        >
          ¡Quiero jugar!
        </Button>
      </div>
    </div>
  )
}

export default ContentProfile
